import "core-js/modules/es6.set";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var _Container = function _Container(vdom) {
  var _a;

  var h = vdom.h || vdom.createElement;
  return _a =
  /*#__PURE__*/
  function (_vdom$Component) {
    _inheritsLoose(Container, _vdom$Component);

    function Container(props) {
      var _this;

      _this = _vdom$Component.call(this, props) || this;
      if (!props.store) throw new Error("Store not found");
      return _this;
    }

    var _proto = Container.prototype;

    _proto.getChildContext = function getChildContext() {
      return {
        store: this.props.store
      };
    };

    _proto.render = function render() {
      var _a = this.props,
          children = _a.children,
          store = _a.store,
          rest = __rest(_a, ["children", "store"]);

      return h("div", rest, children);
    };

    return Container;
  }(vdom.Component), _a.childContextTypes = {
    store: function store() {}
  }, _a;
};

var _mapper = function _mapper(vdom) {
  var h = vdom.h || vdom.createElement;
  return function (propMappings, actionMappings) {
    if (propMappings === void 0) {
      propMappings = {};
    }

    if (actionMappings === void 0) {
      actionMappings = {};
    }

    return function (Wrapped) {
      var _a;

      return _a =
      /*#__PURE__*/
      function (_vdom$Component2) {
        _inheritsLoose(Mapper, _vdom$Component2);

        function Mapper(props, context) {
          var _this2;

          _this2 = _vdom$Component2.call(this, props, context) || this;

          _this2.handleStoreUpdate = function () {
            var hasPropsChanged = false;

            for (var key in propMappings) {
              var prop = propMappings[key](_this2.store, _this2.props);
              if (prop !== _this2.mappedProps[key]) hasPropsChanged = true;
              _this2.mappedProps[key] = prop;
            }

            if (hasPropsChanged) _this2.forceUpdate();
          };

          if (Object.keys(propMappings).length !== 0) _this2.unsubscribe = _this2.store.subscribe(_this2.handleStoreUpdate);
          _this2.mappedProps = {};

          for (var key in propMappings) {
            _this2.mappedProps[key] = propMappings[key](_this2.store, _this2.props);
          }

          _this2.mappedActions = {};

          var _loop = function _loop(_key) {
            _this2.mappedActions[_key] = function () {
              var _actionMappings;

              for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
                args[_key2] = arguments[_key2];
              }

              return (_actionMappings = actionMappings)[_key].apply(_actionMappings, [_this2.store, _this2.props].concat(args));
            };
          };

          for (var _key in actionMappings) {
            _loop(_key);
          }

          return _this2;
        }

        var _proto2 = Mapper.prototype;

        _proto2.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          for (var key in nextProps) {
            if (this.props[key] !== nextProps[key]) return true;
          }

          return false;
        };

        _proto2.componentWillUnmount = function componentWillUnmount() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        };

        _proto2.render = function render() {
          var _a = this.props,
              children = _a.children,
              rest = __rest(_a, ["children"]);

          return h(Wrapped, Object.assign({}, rest, this.mappedProps, this.mappedActions), children);
        };

        _createClass(Mapper, [{
          key: "store",
          get: function get() {
            var store = this.props.store || this.context.store;
            if (!store) throw new Error("Store not found");
            return store;
          }
        }]);

        return Mapper;
      }(vdom.Component), _a.contextTypes = {
        store: function store() {}
      }, _a;
    };
  };
};

var parseStore = function parseStore(jsonStoreData, serializers) {
  if (serializers === void 0) {
    serializers = new Map();
  }

  var data = {};

  try {
    data = JSON.parse(jsonStoreData);
  } catch (e) {}

  for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    try {
      if (serializers.has(key)) {
        data[key] = serializers.get(key).fromUrlValue(value);
      } else {
        data[key] = JSON.parse(value);
      }
    } catch (e) {}
  }

  return data;
};

var getPath = function getPath(store) {
  return store.useHash ? window.location.hash.replace(/^#/, '/') : window.location.pathname + window.location.search;
};

var extractPartsFromPath = function extractPartsFromPath(store) {
  var path = getPath(store);

  var _path$split = path.split('?'),
      pathName = _path$split[0],
      _path$split$ = _path$split[1],
      query = _path$split$ === void 0 ? '' : _path$split$;

  var params = decodeURIComponent(query).split('&');
  return params.reduce(function (acc, pair) {
    if (pair.startsWith('storeData=')) acc.storeData = parseStore(decodeURIComponent(pair.replace(/^storeData=/, '')), store.serializers);else acc.query += (acc.query ? '&' : '') + pair;
    return acc;
  }, {
    pathName: pathName || '/',
    query: '',
    storeData: {}
  });
};

var generateNewUrl = function generateNewUrl(store, newPath) {
  var _extractPartsFromPath = extractPartsFromPath(store),
      pathName = _extractPartsFromPath.pathName,
      query = _extractPartsFromPath.query;

  var data = store.getAll(store.syncToLocations);

  for (var _i2 = 0, _Object$entries2 = Object.entries(data); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _Object$entries2[_i2],
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
    if (store.serializers.has(key)) data[key] = store.serializers.get(key).toUrlValue(value);else data[key] = JSON.stringify(value);
  }

  var storeDataParam = "storeData=" + encodeURIComponent(JSON.stringify(data));
  var nextQuery = query;
  var nextPath = newPath || pathName;
  if (store.syncToLocations && store.syncToLocations.length > 0) nextQuery += (query ? '&' : '') + storeDataParam;
  var url = nextQuery ? nextPath + "?" + nextQuery : nextPath;
  return store.useHash ? url.replace(/^\//, '#') : url;
};

var getStateFromUrl = function getStateFromUrl(store, mountPoints) {
  var _extractPartsFromPath2 = extractPartsFromPath(store),
      storeData = _extractPartsFromPath2.storeData;

  var filteredStoreData = {};
  var mountPointsSet = new Set(mountPoints);
  Object.entries(storeData).forEach(function (_ref) {
    var key = _ref[0],
        data = _ref[1];
    if (mountPointsSet.has(key)) filteredStoreData[key] = data;
  });
  return filteredStoreData;
};

var pushHistory = function pushHistory(store) {
  var newUrl = generateNewUrl(store);
  var currentUrl = getPath(store);

  if (newUrl != currentUrl) {
    history.pushState(null, null, newUrl);
  }
};

var replaceHistory = function replaceHistory(store, newPath) {
  return history.replaceState(null, null, generateNewUrl(store, newPath));
};

var makeSubject = function makeSubject() {
  var observers = new Map();
  var idPtr = 0;
  return {
    subscribe: function subscribe(callback) {
      var id = idPtr;
      idPtr++;
      observers.set(id, callback);
      return function () {
        observers.delete(id);
      };
    },
    next: function next() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
        args[_key3] = arguments[_key3];
      }

      observers.forEach(function (callback) {
        return callback.apply(void 0, args);
      });
    }
  };
};

var immediateScheduler = function immediateScheduler(fn) {
  return fn();
};

var createStore = function createStore(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$initialState = _ref2.initialState,
      initialState = _ref2$initialState === void 0 ? {} : _ref2$initialState,
      _ref2$validators = _ref2.validators,
      validators = _ref2$validators === void 0 ? {} : _ref2$validators,
      _ref2$batchUpdateFn = _ref2.batchUpdateFn,
      batchUpdateFn = _ref2$batchUpdateFn === void 0 ? immediateScheduler : _ref2$batchUpdateFn;

  var state$ = makeSubject();
  var updateIntercepts = [];
  var memory = new Map();
  var batchUpdateInProgress = false;
  var validatorsMap = new Map(Object.entries(validators));

  var validate = function validate(mountPoint, payload) {
    var valid = true;

    if (validatorsMap.has(mountPoint)) {
      var validator = validatorsMap.get(mountPoint);
      valid = validator(payload);
    }

    return valid;
  };

  var notify = function notify() {
    batchUpdateInProgress = false;
    state$.next();
  };

  var ping = function ping() {
    if (!batchUpdateInProgress) {
      batchUpdateInProgress = true;
      batchUpdateFn(notify);
    }
  };

  var update = function update() {
    updateIntercepts.forEach(function (fn) {
      return fn(mutableStore);
    });
    ping();
  };

  var _set = function _set(mountPoint, payload) {
    if (validate(mountPoint, payload)) memory.set(mountPoint, payload);
  };

  var setAll = function setAll(mountPointsAndPayloads) {
    _setAll(mountPointsAndPayloads);

    update();
  };

  var _setAll = function _setAll(mountPointsAndPayloads) {
    Object.entries(mountPointsAndPayloads).forEach(function (_ref3) {
      var mountPoint = _ref3[0],
          payload = _ref3[1];
      return _set(mountPoint, payload);
    });
  };

  setAll(initialState);

  var addUpdateIntercept = function addUpdateIntercept(fn) {
    return updateIntercepts.push(fn);
  };

  var set = function set(mountPoint, payload) {
    _set(mountPoint, payload);

    update();
  };

  var get = function get(mountPoint) {
    return memory.get(mountPoint);
  };

  var getAll = function getAll(mountPoints) {
    return mountPoints.reduce(function (results, mountPoint) {
      return results[mountPoint] = memory.get(mountPoint), results;
    }, {});
  };

  var mutableStore = {
    get: get,
    set: _set,
    getAll: getAll,
    setAll: _setAll
  };

  var withMutations = function withMutations(fn) {
    fn(mutableStore);
    update();
  };

  var storeApi = {
    set: set,
    setAll: setAll,
    get: get,
    getAll: getAll,
    withMutations: withMutations,
    addUpdateIntercept: addUpdateIntercept,
    ping: ping,
    subscribe: function subscribe(listener) {
      return state$.subscribe(function () {
        return listener(storeApi);
      });
    }
  };
  return storeApi;
};

var Match = function Match(vdom) {
  var h = vdom.h || vdom.createElement;
  return function (_a) {
    var path = _a.path,
        currentPath = _a.currentPath,
        children = _a.children,
        rest = __rest(_a, ["path", "currentPath", "children"]);

    var matched = false;

    if (typeof path === "function") {
      matched = path(currentPath);
    } else {
      matched = currentPath.split("?")[0] == path;
    }

    return matched ? h("div", rest, children) : null;
  };
};

var propsFromStore = {
  currentPath: getPath
};

var _Match = function _Match(vdom) {
  return _mapper(vdom)(propsFromStore)(Match(vdom));
};

var handleClick = function handleClick(ev, update) {
  ev.preventDefault();
  update();
};

var Link = function Link(vdom) {
  var h = vdom.h || vdom.createElement;
  return function (_a) {
    var update = _a.update,
        href = _a.href,
        children = _a.children,
        rest = __rest(_a, ["update", "href", "children"]);

    return h('a', Object.assign({
      href: href,
      onClick: function onClick(ev) {
        return handleClick(ev, update);
      }
    }, rest), children);
  };
};

var actionsFromStore = {
  update: function update(store, _ref4) {
    var href = _ref4.href;
    return store.navigate(href);
  }
};

var _Link = function _Link(vdom) {
  return _mapper(vdom)({}, actionsFromStore)(Link(vdom));
};

var debounce = function debounce(time, fn) {
  var timer = null;

  var cancel = function cancel() {
    if (timer) clearTimeout(timer);
    timer = null;
  };

  var debouncer = function debouncer() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
      args[_key4] = arguments[_key4];
    }

    cancel();
    timer = setTimeout(function () {
      return fn.apply(void 0, args);
    }, time);
  };

  debouncer.cancel = cancel;
  return debouncer;
};

var defaultOptions = {
  debounceTime: 500,
  useHash: false
};

var initialiseLastState = function initialiseLastState(store, pushStateMountPoints, replaceStateMountPoints) {
  var lastPushState = [];
  var lastReplaceState = [];
  pushStateMountPoints.forEach(function (mountPoint) {
    return lastPushState.push(store.get(mountPoint));
  });
  replaceStateMountPoints.forEach(function (mountPoint) {
    return lastPushState.push(store.get(mountPoint));
  });
  return [lastPushState, lastReplaceState];
};

var createRouterEnabledStore = function createRouterEnabledStore(_temp2) {
  var _ref5 = _temp2 === void 0 ? {} : _temp2,
      initialState = _ref5.initialState,
      validators = _ref5.validators,
      batchUpdateFn = _ref5.batchUpdateFn,
      _ref5$pushStateMountP = _ref5.pushStateMountPoints,
      pushStateMountPoints = _ref5$pushStateMountP === void 0 ? [] : _ref5$pushStateMountP,
      _ref5$replaceStateMou = _ref5.replaceStateMountPoints,
      replaceStateMountPoints = _ref5$replaceStateMou === void 0 ? [] : _ref5$replaceStateMou,
      _ref5$serializers = _ref5.serializers,
      serializers = _ref5$serializers === void 0 ? {} : _ref5$serializers,
      _ref5$routerOptions = _ref5.routerOptions,
      routerOptions = _ref5$routerOptions === void 0 ? {} : _ref5$routerOptions;

  var _Object$assign = Object.assign({}, defaultOptions, routerOptions),
      debounceTime = _Object$assign.debounceTime,
      useHash = _Object$assign.useHash;

  var routedStore = createStore({
    initialState: initialState,
    validators: validators,
    batchUpdateFn: batchUpdateFn
  });
  var _subscribe = routedStore.subscribe;

  routedStore.subscribe = function (listener) {
    window.addEventListener('popstate', popstate);
    update(routedStore.syncToLocations);
    if (routedStore.syncToLocations.length > 0) replaceHistory(routedStore);

    var unsubscribe = _subscribe(listener);

    return function () {
      window.removeEventListener('popstate', popstate);
      unsubscribe();
    };
  };

  routedStore.serializers = new Map(Object.entries(serializers));

  routedStore.navigate = function (newPath) {
    history.pushState(null, null, generateNewUrl(routedStore, newPath));
    routedStore.ping();
  };

  routedStore.syncToLocations = pushStateMountPoints.concat(replaceStateMountPoints);
  routedStore.useHash = useHash;
  var lastPushState;
  var lastReplaceState;

  var update = function update(mountPoints) {
    routedStore.syncedLocationToStore = true;
    var filteredStoreData = getStateFromUrl(routedStore, mountPoints);
    routedStore.withMutations(function (s) {
      s.setAll(filteredStoreData);

      var _initialiseLastState = initialiseLastState(routedStore, pushStateMountPoints, replaceStateMountPoints);

      lastPushState = _initialiseLastState[0];
      lastReplaceState = _initialiseLastState[1];
    });
    routedStore.syncedLocationToStore = false;
  };

  var popstate = function popstate() {
    update(pushStateMountPoints);
  };

  var debouncedReplaceState = debounce(debounceTime, function () {
    replaceHistory(routedStore);
  });
  routedStore.addUpdateIntercept(function () {
    if (routedStore.syncedLocationToStore) {
      routedStore.syncedLocationToStore = false;
      return;
    }

    var shouldPushState = false;
    var shouldReplaceState = false;
    pushStateMountPoints.forEach(function (mountPoint, idx) {
      var nextProp = routedStore.get(mountPoint);
      if (lastPushState[idx] !== nextProp) shouldPushState = true;
      lastPushState[idx] = nextProp;
    });
    replaceStateMountPoints.forEach(function (mountPoint, idx) {
      var nextProp = routedStore.get(mountPoint);
      if (lastReplaceState[idx] !== nextProp) shouldReplaceState = true;
      lastReplaceState[idx] = nextProp;
    });

    if (shouldPushState) {
      pushHistory(routedStore);
      debouncedReplaceState.cancel();
    } else if (shouldReplaceState) {
      debouncedReplaceState();
    }
  });
  return routedStore;
};

function selectorMemoizer(mapper) {
  for (var _len4 = arguments.length, selectors = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
    selectors[_key5 - 1] = arguments[_key5];
  }

  var lastResult = null;
  var lastProps = null;
  return function (store) {
    var hasPropsChanged = false;

    if (lastProps === null) {
      hasPropsChanged = true;
      lastProps = [];

      for (var i = 0; i < selectors.length; i++) {
        lastProps.push(selectors[i](store));
      }
    } else {
      for (var _i3 = 0; _i3 < selectors.length; _i3++) {
        var prop = selectors[_i3](store);

        if (prop !== lastProps[_i3]) hasPropsChanged = true;
        lastProps[_i3] = prop;
      }
    }

    if (!hasPropsChanged) return lastResult;
    lastResult = mapper.apply(null, lastProps);
    return lastResult;
  };
}

var makeComponents = function makeComponents(vdom) {
  return {
    Container: _Container(vdom),
    mapper: _mapper(vdom),
    Link: _Link(vdom),
    Match: _Match(vdom)
  };
};

export { createStore, selectorMemoizer, createRouterEnabledStore, makeComponents };